import { render, staticRenderFns } from "./QianduanKaifa.vue?vue&type=template&id=c7c115fc&scoped=true&"
import script from "./QianduanKaifa.vue?vue&type=script&lang=js&"
export * from "./QianduanKaifa.vue?vue&type=script&lang=js&"
import style0 from "./QianduanKaifa.vue?vue&type=style&index=0&id=c7c115fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c115fc",
  null
  
)

export default component.exports